import WeddingsRegistration from './WeddingsRegistration';

export default WeddingsRegistration;
